import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import '../sass/styles.scss'
import Header from '../components/nav/header'
import Cart from '../components/checkout/cart'

const Layout = ({ children }) => {
  return (
    <div>
      <Helmet>
        <link rel="preconnect" href="https://cdn.shopify.com" />
      </Helmet>
      <Header></Header>
      {children}
      <Cart></Cart>
    </div>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
